
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MsalGuard } from '@azure/msal-angular';
import { Constant } from './modules/shared/constants';
import { TestComponent } from './test/test.component';

const isInIframe = window !== window.parent && !window.opener;
const guards = isInIframe ? [] : [MsalGuard];

const routes: Routes = [
  
  { 
    path: '',
    canActivate: guards, 
    loadChildren: () => import('./AML/aml-home.module').then(m => m.AmlHomeModule) 
  },
  {
    path:'',
    redirectTo: 'home',
    pathMatch: 'full'
  },

  {
   
    path:'test',
    component: TestComponent,
   
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
